import { Node, mergeAttributes } from '@tiptap/core';

// an org-authored placeholder chip: it carries only a name, and staff fill in
// its value when the agreement is sent
export const CustomVariableNode = Node.create({
  name: 'customVariable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-custom-variable') || '',
        renderHTML: (attributes) => ({ 'data-custom-variable': attributes.name }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-custom-variable]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'agreement-variable' }),
      node.attrs.name || 'Custom Field',
    ];
  },
});

// mirrors CollectCustomVariables in backend/app/utils/rentals_pdf — the custom
// variable names of a template, in order and without duplicates, so the send
// dialog can ask for each value
export function collectCustomVariables(template: string): string[] {
  if (!template) {
    return [];
  }
  let document: any;
  try {
    document = JSON.parse(template);
  } catch {
    return [];
  }
  const names: string[] = [];
  const seen = new Set<string>();
  const walk = (node: any) => {
    if (!node) {
      return;
    }
    if (node.type === 'customVariable') {
      const name = node.attrs?.name || '';
      if (name && !seen.has(name)) {
        seen.add(name);
        names.push(name);
      }
    }
    (node.content || []).forEach(walk);
  };
  walk(document);
  return names;
}
